import * as Types from '../../../gen/types';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from '@vue/composition-api';
export type ReactiveFunction<TParam> = () => TParam;
export type DeleteCalendarMutationVariables = Types.Exact<{
  accessToken: Types.Scalars['String'];
  id: Types.Scalars['ID'];
}>;


export type DeleteCalendarMutation = (
  { __typename?: 'Mutation' }
  & { deleteCalendar: (
    { __typename?: 'Reservation' }
    & Pick<Types.Reservation, 'id'>
  ) }
);


export const DeleteCalendarDocument = gql`
    mutation deleteCalendar($accessToken: String!, $id: ID!) {
  deleteCalendar(accessToken: $accessToken, id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteCalendarMutation__
 *
 * To run a mutation, you first call `useDeleteCalendarMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCalendarMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCalendarMutation({
 *   variables: {
 *     accessToken: // value for 'accessToken'
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCalendarMutation(options: VueApolloComposable.UseMutationOptions<DeleteCalendarMutation, DeleteCalendarMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCalendarMutation, DeleteCalendarMutationVariables>>) {
  return VueApolloComposable.useMutation<DeleteCalendarMutation, DeleteCalendarMutationVariables>(DeleteCalendarDocument, options);
}
export type DeleteCalendarMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCalendarMutation, DeleteCalendarMutationVariables>;